import { useSubject }                                       from 'ClientService/HookApi';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector }                         from 'react-redux';
import {
    getEvalYears, isFilterRequestLoading,
} from 'Redux/Query';
import { debounceTime, takeUntil }                 from 'rxjs/operators';
import { findEvalYearsRequest }                    from 'Redux/Action';
import Transfer                                    from 'Common/Transfer/Transfer';

export const EvalYearTransfer = ({ value, defaultValue, onChange }) => {

    const dispatch = useDispatch();

    let _defaultValue = defaultValue ?? [];
    _defaultValue = Array.isArray(_defaultValue) ? _defaultValue : [_defaultValue] || [];

    const [ targetKeys, setTargetKeys ] = useState(_defaultValue);

    const onDestroy$ = useSubject(() => {});

    const onSearch$ = useSubject((value) => {
        const filterProps = {
            sorting   : { field: '`Result`.`eval_year`', order: 'ASC' },
            pagination: { page: 1, take: 2000 }
        };
        if (!value || `${value}`.trim() === '') {
            return dispatch(findEvalYearsRequest(filterProps));
        }
        dispatch(findEvalYearsRequest({
            filter: [ { field: '`Result`.`eval_year`', value: `%${value}%` } ],
            ...filterProps,
        }));
    }, takeUntil(onDestroy$), debounceTime(500));

    const evalYears  = useSelector(getEvalYears);
    const isLoading = useSelector(isFilterRequestLoading);


    const handleOnChange = useCallback((targetKeys) => {
        setTargetKeys(targetKeys);
        if (onChange && typeof onChange === 'function') {
            onChange(targetKeys);
        }
    }, []);

    const handleOnSearch = useCallback((direction, value) => {
        if (direction === 'right') {
            return;
        }
        onSearch$.next(value);
    }, []);

    useEffect(() => {
        if(!value) { return }
        setTargetKeys(Array.isArray(value) ? value : [value]);
    }, [value]);

    useEffect(() => {
        onSearch$.next();

        return () => {
            onDestroy$.next();
            onDestroy$.complete();
        };
    }, []);

    const dataSource = useMemo(() => {
        return [... new Set([ ...evalYears].concat(targetKeys))]
    }, [evalYears, targetKeys])

    return (
        <Transfer
            isLoading={isLoading}
            header={[ 'Verfügbare Auswertungsjahre', 'Ausgewählte Auswertungsjahre' ]}
            dataSource={dataSource.map(year => ({
                key  : year,
                title: year,
            }))}
            targetKeys={targetKeys}
            locale={{
                itemUnit       : 'AJ',
                itemsUnit      : 'AJ',
                notFoundContent: 'Keine AJ gefunden',
            }}
            onChange={handleOnChange}
            onSearch={handleOnSearch}
            filterOption={(input, { title }) => `${title}`.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            showSearch
            listStyle={{ height: 400 }}
            render={item => `${item.title}`}
            operations={[ 'zuordnen', 'entfernen' ]}
        />
    );

};
